import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { firestore } from '../../config/firebase';
import { clearSeller, fetchSellersList, deleteSeller } from '../../store/actions/sellerActions';
import SellerItem from './SellerItem/SellerItem';
import Spinner from '../UIComponents/Spinner';
import Swal from 'sweetalert2';
import lang from './lang';
import './Sellers.css';

class Sellers extends Component {
    state = {
        sellers: [],
        msg: {
            msg: '',
            msgType: 'success',
            msgStatus: false,
        },
        display: 'none'
    }

    removeSellerHandler = (id) => {
        // Delete the seller from store
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you really want to delete the user?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                this.setState({ display: 'flex' })
                axios(`/users/delete/${id}`)
                    .then(res => {
                        if (res.data.success) {
                            firestore.collection('users')
                                .doc(this.props.user.id)
                                .collection('sellers')
                                .doc(id)
                                .delete();
                            // delete seller from sellers collection
                            firestore.collection('sellers')
                                .doc(id).delete();
                            this.setState({
                                msg: {
                                    msg: res.data.msg[this.props.user.lang],
                                    msgStatus: true,
                                    msgType: res.data.msgType
                                },
                                display: 'none'
                            });
                            this.props.deleteSeller(id);
                        } else {
                            this.setState({
                                msg: {
                                    msg: res.data.msg[this.props.user.lang],
                                    msgStatus: true,
                                    msgType: res.data.msgType
                                },
                                display: 'none'
                            });
                        }
                    })
                    .catch(err => {
                        this.setState({
                            msg: {
                                msg: err.msg[this.props.user.lang],
                                msgStatus: true,
                                msgType: 'danger'
                            },
                            display: 'none'
                        })
                        console.log(err)
                    })
            }
        })

    }

    alertMessageHandler = () => {
        this.setState({ msg: { msgStatus: false } });
    }

    render() {
        const {
            sellers: {
                title,
                btn,
                tName,
                tPhone,
                tType,
                tEmail,
                tPassword,
                actions
            },
            add: { manager, seller }
        } = lang[this.props.user.lang || 'uz']
        console.log(this.props.sellers);

        return (
            <div className="mt-5" id="sellers-page">
                <Spinner display={this.state.display} />
                <div
                    className={`alert alert-${this.state.msg.msgType} mb-5`}
                    style={{ display: this.state.msg.msgStatus ? 'block' : 'none' }}
                >
                    <strong>{this.state.msg.msg}</strong>
                    <button type="button" className="close" onClick={() => this.alertMessageHandler()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <h3>{title}</h3>
                {
                    this.props.sellers.length < 3 ?
                        (
                            <div className="text-right">
                                <Link to="/sellers/new" className="btn btn-primary">+ {btn}</Link>
                            </div>
                        ) : null
                }
                <div className="list-group list-group-flush mt-3">
                    <table className="table table-striped table-responsive-md">
                        <thead className="thead-dark">
                            <tr>
                                <th>{tName}</th>
                                <th>{tPhone}</th>
                                <th>{tType}</th>
                                <th>{tEmail}</th>
                                <th>{tPassword}</th>
                                <th>{actions}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.sellers.map((item, index) => {
                                    return (
                                        <SellerItem
                                            id={item.id}
                                            key={index}
                                            name={item.name}
                                            phone={item.phone}
                                            email={item.email}
                                            delete={this.removeSellerHandler}
                                            password={item.password}
                                            type={item.type}
                                            translation={{ manager, seller }}
                                        />
                                    )
                                })
                            }
                        </tbody>
                    </table>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        sellers: state.sellers.sellers
    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearSeller: () => dispatch(clearSeller()),
        deleteSeller: (id) => dispatch(deleteSeller(id)),
        fetchSellers: (data) => dispatch(fetchSellersList(data)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Sellers);